var _path, _g, _rect, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRemoveBurglary(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68 0H8C3.58172 0 0 3.58172 0 8V68C0 72.4183 3.58172 76 8 76H68C72.4183 76 76 72.4183 76 68V8C76 3.58172 72.4183 0 68 0Z",
    fill: "#FCEBE3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_229_289)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58 14H8V64H58V14Z",
    fill: "#FCEBE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3405 27.8676C46.1143 27.486 47.2546 25.705 46.8745 23.9241C46.4944 22.1432 44.7206 20.8711 42.9469 21.2527C41.1731 21.6344 40.0329 23.4153 40.4129 25.1962C40.793 27.1043 42.5668 28.2492 44.3405 27.8676Z",
    fill: "#02475E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.082 25.0684C20.6477 26.4677 18.8739 29.5207 19.7608 32.1921C20.6477 34.8635 23.6884 35.8811 28.1228 34.4819C32.4305 33.0826 38.0051 27.9942 37.625 26.5949C36.9915 24.9412 29.3897 23.6691 25.082 25.0684Z",
    fill: "#F78670"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1132 31.4281C45.3531 31.0464 44.3395 31.3009 43.9594 32.1913L43.3259 33.4634L42.5657 29.3927C42.439 29.0111 42.059 28.5023 42.059 28.5023C41.5522 27.8662 40.9187 27.6118 40.2852 27.6118C39.6517 27.6118 39.0182 27.8662 38.6381 28.3751L31.4164 35.626C31.163 35.8804 29.0092 37.7885 28.6291 39.8238L27.4888 46.5659L21.2807 45.6754C20.2671 45.5482 19.1268 46.057 19.0001 47.0747C18.7467 48.9828 21.0273 49.2373 21.0273 49.2373C21.0273 49.2373 27.9956 50.3821 29.6427 50.3821C30.9096 50.2549 31.6698 49.11 31.7965 48.474C32.1766 46.4387 33.1902 42.7496 33.1902 42.7496C33.1902 42.7496 36.1042 45.6754 37.2445 47.2019L38.7648 55.3433C38.7648 55.5977 38.8915 55.7249 38.8915 55.8521H22.801V57.1242H40.6653C40.792 57.1242 40.9187 57.1242 41.0454 57.1242C42.3123 56.8698 42.5657 55.8521 42.439 54.58L41.2988 46.6931C41.2988 46.1843 41.0454 45.1666 40.6653 44.6578C40.6653 44.6578 37.878 41.0959 36.9911 39.951L40.5386 36.3892L41.0454 38.8062C41.1721 39.4422 41.6789 40.0782 42.439 40.0782C42.5657 40.0782 42.5657 40.0782 42.6924 40.0782C43.3259 40.0782 43.8327 39.6966 44.0861 39.1878L46.8734 33.5906C47.2535 32.8274 47.0001 31.8097 46.1132 31.4281Z",
    fill: "#02475E"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 9,
    width: 17,
    height: 17,
    rx: 5.66667,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1663 17.5C62.1663 14.3715 59.6281 11.8333 56.4997 11.8333C53.3712 11.8333 50.833 14.3715 50.833 17.5C50.833 20.6285 53.3712 23.1667 56.4997 23.1667C59.6281 23.1667 62.1663 20.6285 62.1663 17.5Z",
    fill: "#EB5757"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8619 17.5009H54.1396",
    stroke: "white",
    strokeWidth: 1.41667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_229_289"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(8 14)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveBurglary);
export default __webpack_public_path__ + "static/media/RemoveBurglary.2b749d870367cb55e18c4d261779ac68.svg";
export { ForwardRef as ReactComponent };